
/* eslint-disable no-extend-native */

"use strict";

let UniqueLogonDialog = false;

const UserTimeFormat = function () {
    return EC_Fmt.userTimeFormat;
};
// Trim is not available for Excel, this adds it
if (typeof String.prototype.trim !== "function") {
    String.prototype.trim = function () {
        return this.replace(/^\s+|\s+$/g, "");
    };
}

function FData(inputObj, dataType, length, required) {
    return EC_Fmt.InputFmt(inputObj, dataType, length, required);
}

function SiteRequiresSupportEditMemo() {
    // Task 1002952: Exchange Map Field Audits do not have Task ID, always require Task ID when editing Master Shared tables
    return (((UserType === "Support" && !TestDatabase) || ((UserType === "Support" || Distributor.startsWith("Support")) && document.getElementById("DatabaseOfCurrentTableIsMasterShared"))) && SiteIsLive);
}

function formatCurrency(num) {
    return EC_Fmt.InputFmt(num, ECP.DataType._Currency);
}

function getQueryVariable(variable) {
    const query = window.location.search.substring(1);
    const vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split("=");
        if (pair[0] === variable) { return pair[1]; }
    }
    return (false);
}

function getDistributor() {
    const EncompassID = getQueryVariable("EncompassID");
    if (EncompassID) {
        return EncompassID;
    }
    return getQueryVariable("Distributor");
}

// Safari (through 27, iOS 26) ships requestIdleCallback only behind an experimental flag, so keep a timer-based stand-in
if (!window.requestIdleCallback) {
    window.requestIdleCallback = function (callback) {
        const start = Date.now();
        return setTimeout(() => {
            callback({
                didTimeout: false,
                timeRemaining() {
                    return Math.max(0, 50 - (Date.now() - start));
                }
            });
        }, 1);
    };
    window.cancelIdleCallback = function (handle) {
        clearTimeout(handle);
    };
}

window.debounce = function (func, wait, ...args) {
    let timer;
    return function () {
        const context = this;
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(context, args);
        }, wait);
    };
};

const BC_EWS = function () {
    const me = this;

    this.Instance = 0;
    this.AllowResize = true;
    this.LoadingDelay = 0;
    this.Interval = 60000;
    this.Ctrl = false;
    this.Shift = false;
    this.Fullscreen = false;
    this.FullscreenTimer = null;

    this.HTML5 = true;

    document.addEventListener("DOMContentLoaded", () => {
        // Task 720388: Unable to set password when browser is blocking cookies fix error message to explain problem to user
        if (!navigator.cookieEnabled) {
            ECP.Dialog.Alert("Your browser does not have cookies enabled. Cookies are required to use this site.");
        }

        if (EC_Fmt.Browser === ECP.Browser.Safari) {
            let interval;

            const iOSTextSelectFunction = (event) => {
                const inputElement = event.currentTarget;

                clearInterval(interval);
                interval = setInterval(() => {
                    const ratio = inputElement.scrollWidth / inputElement.value.length;

                    if (inputElement) {
                        const width = inputElement.offsetWidth;

                        if (width < inputElement.scrollWidth) {
                            const x = inputElement.selectionStart;
                            const x2 = inputElement.selectionEnd;
                            const cursorPositionS = x - inputElement.scrollLeft / ratio;
                            const cursorPositionE = x2 - inputElement.scrollLeft / ratio;

                            if (cursorPositionS === cursorPositionE) {
                                if (cursorPositionS < 1) {
                                    inputElement.scrollLeft -= ratio;
                                }
                                if (cursorPositionE > (width / ratio) - 1) {
                                    inputElement.scrollLeft += ratio;
                                }
                            } else {
                                inputElement.setSelectionRange(x, x2);
                            }
                        }
                    } else {
                        clearInterval(interval);
                    }
                }, 100);
            };

            const ClearIntervalIOSTextSelection = () => {
                clearInterval(interval);
            };

            const textInputs = document.querySelectorAll("input[type='text']");
            for (let i = 0; i < textInputs.length; i++) {
                textInputs[i].addEventListener("focus", iOSTextSelectFunction);
                textInputs[i].addEventListener("blur", ClearIntervalIOSTextSelection);
            }
        }
        //  because Users are Not signing up Salesmen for Pre-Delivery Notices because they don't know what word means.Encompass Mobile Alert should link user to Local Invoice View
        if (EC_Fmt.isMobile) {
            const MobileURL = EC_Fmt.GetPageParameter("MobileURL");
            if (MobileURL) {
                window.location = MobileURL;
            }
        }

        Date.prototype.getWeekNumber = function () {
            const current = new Date(+this);

            current.setHours(0, 0, 0, 0);
            current.setDate(current.getDate() + 4 - (current.getDay() || 7));

            return Math.ceil((((current - new Date(current.getFullYear(), 0, 1)) / 8.64e7) + 1) / 7);
        };

        const currentTagLinks = document.querySelectorAll("a[href='#']");
        for (let i = 0; i < currentTagLinks.length; i++) {
            currentTagLinks[i].addEventListener("click", () => false);
        }

        me.FixChromeAutocomplete();

        window.addEventListener("resize", me.Resize);
        me.AjaxInputs = {};
        const AjaxInputs = document.querySelectorAll("input[KeyValue][DisplayVal][LimitToList]");
        for (let i = 0; i < AjaxInputs.length; i += 1) {
            const FieldID = AjaxInputs[i].closest("section").getAttribute("FieldID");
            me.AjaxInputs[FieldID] = new ECP.HTML.AjaxInput(AjaxInputs[i]);
        }

        // EC-29365: Tell the service worker which user this session belongs to, before me.Ready() triggers API calls
        if ("serviceWorker" in navigator && EC_Fmt.Browser !== ECP.Browser.Firefox) {
            const registerUserContext = () => {
                if (navigator.serviceWorker.controller) {
                    navigator.serviceWorker.controller.postMessage({
                        type: "REGISTER_USER_CONTEXT",
                        userKey: (typeof UserID !== "undefined" && typeof Distributor !== "undefined") ? `${Distributor}_${UserID}` : ""
                    });
                }
            };
            registerUserContext();
            navigator.serviceWorker.addEventListener("controllerchange", registerUserContext);
            navigator.serviceWorker.addEventListener("message", (event) => {
                if (event.data && event.data.type === "SW_RESTARTED") {
                    registerUserContext();
                }
            });
        }

        me.Ready();
        me.Resize();

        // Task 569618

        document.addEventListener("visibilitychange", () => {
            if (document.visibilityState === "visible" && !IsImpersonateUser) {
                this.VerifySession(() => {
                    const LogonDialog = document.querySelector(".ecp-Logon-dialog");
                    if (LogonDialog) {
                        LogonDialog.style.display = "none";
                    }
                    const LogonDialogMask = document.querySelector("div.ews-dialog-modal");
                    if (LogonDialogMask) {
                        LogonDialogMask.style.display = "none";
                    }
                });
            }
        }, false);

        if (window.self === window.top) {
            me.StartPageTimer();
        }

        // Task 713025: Adding PWA functionality for ECP
        if ("serviceWorker" in navigator && EC_Fmt.Browser !== ECP.Browser.Firefox) {
            if (ReleasedCode) {
                navigator.serviceWorker.register("ServiceWorker.min.js").catch(() => { });
            } else {
                navigator.serviceWorker.register("ServiceWorker.js").catch(() => { });
            }
        }
    });
};

BC_EWS.prototype.Alert = (message) => {
    ECP.Dialog.Alert(message);
};

BC_EWS.prototype.Confirm = function (message, confirmed, canceled) {
    ECP.Dialog.ShowDialog("Confirm", `<table style=width:100%;height:100% class=NoPadding><tr><td id=ews-confirm-message style=text-align:center>${message}</td></tr></table>`, {
        width: 450,
        height: 200,
        cancelButtonTitle: "Cancel",
        confirmButtonTitle: "OK",
        cancelButtonAction() {
            if (canceled) {
                canceled();
            }
        },
        confirmButtonAction(dialog) {
            ECP.Dialog.CloseDialog(dialog);

            if (confirmed) {
                confirmed();
            }
        }
    });
};

/**
 * Request geolocation using the modern <geolocation> HTML element (Chrome 144+)
 * with progressive enhancement fallback to the legacy navigator.geolocation API.
 * @param {string|HTMLElement} targetForm - Form ID or element containing #Latitude and #Longitude inputs
 */
BC_EWS.prototype.RequestGeolocation = function (targetForm) {
    const form = typeof targetForm === "string" ? document.getElementById(targetForm) : targetForm;
    if (!form) return;

    const updateFormCoords = (position) => {
        const latInput = form.querySelector("#Latitude");
        const lngInput = form.querySelector("#Longitude");
        if (latInput) latInput.value = position.coords.latitude;
        if (lngInput) lngInput.value = position.coords.longitude;
    };

    // Feature detection for modern <geolocation> element (Chrome 144+)
    if ("HTMLGeolocationElement" in window) {
        // Create the geolocation element with autolocate for silent permission (if already granted)
        const geoElement = document.createElement("geolocation");
        geoElement.setAttribute("autolocate", "");
        geoElement.setAttribute("accuracymode", "approximate");
        // Use visibility:hidden instead of display:none - element must be "in the page" to work
        geoElement.style.cssText = "position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);";

        const handleLocation = () => {
            if (geoElement.position) {
                updateFormCoords(geoElement.position);
            }
            geoElement.remove();
        };

        // The 'location' event fires when position data is available
        geoElement.onlocation = handleLocation;
        document.body.appendChild(geoElement);
    } else if (navigator.geolocation) {
        // Fallback to legacy API for browsers that don't support <geolocation>
        requestAnimationFrame(() => {
            navigator.geolocation.getCurrentPosition(updateFormCoords);
        });
    }
};

// EC-30444: On localhost the server bypasses captcha verification (BC_Auth.VerifyLoginCaptcha), so skip
// loading/executing reCAPTCHA entirely - keeps developers from hitting the script load and any challenge.
function IsLoginCaptchaBypassed() {
    const host = window.location.hostname;
    return host === "localhost" || host === "127.0.0.1" || host === "::1" || host === "[::1]";
}

// EC-30350: Fetch an invisible reCAPTCHA v3 token for login. Resolves to "" if reCAPTCHA is unavailable;
// the server treats an empty/low-confidence token as a step-up (v2 checkbox), not a hard failure.
function GetLoginCaptchaV3Token() {
    if (IsLoginCaptchaBypassed()) {
        return Promise.resolve("");
    }
    return new Promise((resolve) => {
        let settled = false;
        const finish = (value) => {
            if (settled) {
                return;
            }
            settled = true;
            resolve(value);
        };
        // If the reCAPTCHA script fails to load or never invokes the callback, the Promise would hang and
        // freeze the login dialog. Time out to "" so the server treats it as a step-up to the v2 checkbox.
        setTimeout(() => finish(""), 8000);
        try {
            ECP.Tools.CaptchaV3("Login", token => finish(EC_Fmt.isNull(token) ? "" : token));
        } catch (e) {
            finish("");
        }
    });
}

// EC-30350: Step-up challenge - show the visible v2 "I'm not a robot" checkbox in a dialog and resolve
// with the solved token (or "" if the user dismisses it without solving).
function ShowLoginCaptchaChallenge() {
    return new Promise((resolve) => {
        const container = document.createElement("div");
        container.style.cssText = "display:flex;justify-content:center;padding:16px";
        ECP.Dialog.HideLoading();
        const dialog = ECP.Dialog.ShowDialog("Verify you are human", container, { height: "auto", disableButtons: true });
        ECP.Tools.CaptchaV2(container, (token) => {
            ECP.Dialog.CloseDialog(dialog);
            resolve(EC_Fmt.isNull(token) ? "" : token);
        });
    });
}

// EC-30350: Submit a Logon_Guest request with bot verification - invisible v3 first, then step up to the
// v2 checkbox when the server responds "requireCaptcha". Returns the final logon result.
BC_EWS.prototype.SubmitLogonRequest = async function (style, theme, latitude, longitude) {
    const buildRequest = (captchaToken, captchaTokenV2) => {
        const request = new ECP.EC_Request("Logon_Guest");
        request.SetAPIToken("33c9305a94a58896fd87f0efd2411380");
        request.AddRequestVariable("Style", style, ECP.EC_Verb.Post);
        request.AddRequestVariable("Theme", theme, ECP.EC_Verb.Post);
        request.AddRequestVariable("Latitude", latitude, ECP.EC_Verb.Post);
        request.AddRequestVariable("Longitude", longitude, ECP.EC_Verb.Post);
        request.AddRequestVariable("CaptchaToken", captchaToken, ECP.EC_Verb.Post);
        request.AddRequestVariable("CaptchaTokenV2", captchaTokenV2, ECP.EC_Verb.Post);
        return request;
    };

    const v3Token = await GetLoginCaptchaV3Token();
    let result = await buildRequest(v3Token, "").Submit();

    if (result.status === "requireCaptcha") {
        const v2Token = await ShowLoginCaptchaChallenge();
        if (EC_Fmt.isNull(v2Token)) {
            return { status: "fail", message: "Verification was not completed. Please try again." };
        }
        result = await buildRequest("", v2Token).Submit();
    }

    // Never hand a message-less / unexpected response back to the login handlers - they call
    // result.message.indexOf() and would throw. Normalize anything that isn't a known status to a fail.
    if (EC_Fmt.isNull(result) || (result.status !== "success" && result.status !== "expired" && result.status !== "requireMFA" && EC_Fmt.isNull(result.message))) {
        return { status: "fail", message: "We couldn't verify you are human. Please try again." };
    }

    return result;
};

BC_EWS.prototype.EncryptLogin = function (form) {
    const me = this;

    // Task 429466 - Updated to use <geolocation> HTML element (Chrome 144+) with fallback
    me.RequestGeolocation("LogonForm");
    if (typeof form === "string") {
        form = document.querySelector(form);
    }

    if (form instanceof HTMLElement) {
        form.action = "Home";
        form.addEventListener("submit", async (event) => {
            event.preventDefault();
            me.EncryptLoginDivert(event.currentTarget);
            // Task 707913: DevOps: Convert DashboardItemType to DashboardWidget.
            // Task 1100879: Long running query of Logon_Guest
            if (!EC_Fmt.isNull(form.querySelector("#Theme").value)) {
                ECP.Dialog.ShowLoading("Logging On...");
                const result = await me.SubmitLogonRequest(
                    form.querySelector("#Style").value,
                    form.querySelector("#Theme").value,
                    form.querySelector("#Latitude").value,
                    form.querySelector("#Longitude").value
                );

                if (result.status === "requireMFA") {
                    ECP.Dialog.HideLoading();
                    const mfaResult = await EWS.CheckMFAStatus(result.message, result.type, result.token, result.passkeyOptions);
                    if (mfaResult === "True") {
                        result.status = "success";
                    } else {
                        result.status = "fail";
                        result.message = mfaResult;
                    }
                }

                if (result.status === "success" || result.status === "expired") {
                    // Task 1033298: Adding Google Analytics as a default feature of dashboards
                    gtag("event", "relogin", { status: result.status });
                    const DestURL = form.querySelector("#DestURL").value;
                    // Task 1010255: Redirect users to the URL in setting 38 just before the login cookies are set- consistent URL when logged in for all users
                    if (EC_Fmt.isNull(result.redirectURL) || result.redirectURL.indexOf(window.location.hostname) !== -1) {
                        if (!EC_Fmt.isNull(DestURL)) {
                            try {
                                const parsedUrl = new URL(DestURL);
                                window.location.href = parsedUrl.pathname;
                            } catch (e) {
                                window.location.href = DestURL;
                            }
                        } else {
                            window.location.href = "Home";
                        }
                    } else {
                        let postURL = result.redirectURL;
                        if (!EC_Fmt.isNull(DestURL)) {
                            postURL += "&DestURL=";
                            postURL += encodeURIComponent(DestURL);
                        }
                        const tempForm = document.createElement("form");
                        tempForm.id = 38;
                        tempForm.action = postURL;
                        tempForm.method = "post";
                        tempForm.style.display = "none";
                        // TD-098: a single use transfer token, the session cookie is HttpOnly and never reaches script
                        const opt = document.createElement("input");
                        opt.type = "hidden";
                        opt.name = "LogonTransferToken";
                        opt.value = result.logonTransferToken;
                        tempForm.appendChild(opt);
                        document.body.appendChild(tempForm);
                        tempForm.submit();
                    }
                } else if (result.message.indexOf("2|") === 0) {
                    form.style.display = "block";
                    const loginDialogData = await DisplayLogon(result.message);
                    // Task 1118614: Unable to log in with user with multiple roles on desktop
                    ECP.Dialog.ShowDialog("Logon", loginDialogData, { height: "auto", disableButtons: true });
                    ECP.Dialog.HideLoading();
                } else {
                    if (!EC_Fmt.isNull(document.getElementById("ews-login-field-error"))) {
                        document.getElementById("ews-login-field-error").parentNode.removeChild(document.getElementById("ews-login-field-error"));
                    }
                    const errorsMessage = document.getElementById("errormessage");
                    // Task 1035074: Replace login error message with <ecp-sectionmessage> component
                    if (result.message.indexOf("<br>") === 0) {
                        errorsMessage.innerHTML = `<ecp-sectionmessage class=ecp-logon-tips type=error>${result.message.slice(4)}</ecp-sectionmessage>`;
                    } else {
                        errorsMessage.innerHTML = `<ecp-sectionmessage class=ecp-logon-tips type=error>${result.message}</ecp-sectionmessage>`;
                    }
                    // Task 1016513: User John Akins unable to login to Encompass on the server and Encompass Mobile'ReferenceError: Can't find variable: errorsmessage'
                    document.getElementById("errormessage").firstChild.firstChild.style.minHeight = 0;
                    // Task 839924: Site Login: When username/password is incorrect focus is put in Password box instead of Username
                    document.getElementById("ews-login-password").focus();
                    // Task 983319: Require OAuth login on Roles
                    if (result.message === "Users in this role are required to Log In with OAuth.") {
                        const LogonForm = document.getElementById("LogonForm");
                        if (LogonForm) {
                            LogonForm.style.display = "none";
                        }
                        const resetPasswordBtn = document.getElementById("reset-pwd-btn");
                        if (resetPasswordBtn) {
                            resetPasswordBtn.style.display = "none";
                        }
                    }
                    ECP.Dialog.HideLoading();
                }
            }
            return false;
        });
    }
};

const DES = () => {
    const form = document.getElementById("LoginForm");

    let username = form.querySelector("#UserNameHidden").value;
    let support = false;

    username = username.toLowerCase().trim();

    if (username.endsWith("$")) {
        username = username.slice(0, -1);
        support = true;
    }
    username = EC_Fmt.MD5(username);

    if (support) {
        username += "$";
    }

    form.querySelector("#Style").value = username;
    form.submit();
};

BC_EWS.prototype.EncryptLoginDivert = (form) => {
    // Task 1080985: The timeout login box/page does not work
    const usernameField = form.querySelector("#ews-login-username");
    const passwordField = form.querySelector("#ews-login-password");
    let username = usernameField.value;
    let password = passwordField.value;

    passwordField.value = "";

    let support = false;
    username = username.toLowerCase().trim();

    if (username.endsWith("$")) {
        username = username.slice(0, -1);
        support = true;
    }

    const isEmail = EC_Fmt.isEmail(username);

    username = EC_Fmt.MD5(username);
    if (!EC_Fmt.isNull(password)) {
        password = EC_Fmt.MD5(password);
    }
    if (support) {
        username += "$";
    }

    if (isEmail) {
        username = `@${username}`;
    }

    form.querySelector("#Style").value = username;
    form.querySelector("#Theme").value = password;

    return form;
};

BC_EWS.prototype.FixChromeAutocomplete = () => {
    if (EC_Fmt.Browser === ECP.Browser.Chrome) {
        requestAnimationFrame(() => {
            const textInputs = document.querySelectorAll("input[type='text']");
            for (let i = 0, len = textInputs.length; i < len; i++) {
                textInputs[i].autocomplete = "off";
            }
        });
    }
};

BC_EWS.prototype.FormData = () => new FormData();

BC_EWS.prototype.IsFloat = value => EC_Fmt.isNumber(value);

BC_EWS.prototype.Selector = (value) => {
    if (value && value !== "") {
        return value.toString().replace(/(:|\.|\[|\]|\^|\/)/g, "\\$1");
    }
    return "";
};

BC_EWS.prototype.ShowLoading = (delay, cover, loadingText, hidingFromBackForward) => {
    if (cover instanceof HTMLElement) {
        let mySelector = EC_Fmt.MD5(new Date().toString());
        cover.classList.add(mySelector);
        mySelector = `[class*='${mySelector}']`;
        ECP.Dialog.ShowLoading(loadingText, mySelector);
    } else {
        ECP.Dialog.ShowLoading(loadingText);
    }
    if (hidingFromBackForward) {
        const hideTimer = setInterval(() => {
            if (performance.getEntriesByType("navigation")[0]?.type === "back_forward") {
                EWS.HideLoading();

                clearInterval(hideTimer);
            }
        }, 500);
    }
};

BC_EWS.prototype.StartPageTimer = function () {
    const me = this;

    this.PageInterval = window.setInterval(() => {
        me.PageTimer();
    }, this.Interval);
};

BC_EWS.prototype.StopPageTimer = function () {
    window.clearInterval(this.PageInterval);
};

BC_EWS.prototype.HideLoading = () => {
    ECP.Dialog.HideLoading();
};

BC_EWS.prototype.Load = function (script, callback) {
    const me = this;
    if (EC_Fmt.isNull(me.LoadedScripts)) {
        me.LoadedScripts = [];
    }
    // Task 388737

    if (me.LoadedScripts.indexOf(script) < 0) {
        const jsScript = document.createElement("script");
        jsScript.type = "text/javascript";
        jsScript.src = script;
        jsScript.async = true;
        jsScript.onload = function () {
            me.LoadedScripts.push(script);

            if (!EC_Fmt.isNull(callback)) {
                requestIdleCallback(() => {
                    callback();
                }, { timeout: 250 });
            }
        };

        document.getElementsByTagName("head")[0].appendChild(jsScript);
    } else if (!EC_Fmt.isNull(callback)) {
        callback();
    }
};

BC_EWS.prototype.Login = async function (callback) {
    const me = this;

    let loginDialog = document.querySelector(".ecp-Logon-dialog");
    if (loginDialog) {
        loginDialog.style.display = "block";
    } else if (!UniqueLogonDialog) {
        UniqueLogonDialog = true;
        // Task 628953: API Token for Encompass_DevOps_Public located in multiple.js files.
        const myRequest = new ECP.EC_Request("Dialog_Session_Expires_Logon_Guest");
        myRequest.AddRequestVariable("Mobile", EC_Fmt.isMobile);
        myRequest.SetAPIToken("33c9305a94a58896fd87f0efd2411380");

        const myResult = await myRequest.Submit();
        // Task 1068633: Two login dialogs appear after session times out
        loginDialog = document.querySelector(".ecp-Logon-dialog");
        if (loginDialog) {
            loginDialog.style.display = "block";
        } else {
            const Dialog = ECP.Dialog.ShowDialog("Log in", myResult.content, {
                disableResize: true,
                width: 370,
                // Task 1061314: Login dialog contains a scroll bar if there are OAuth sign in options- Making the dialog slightly taller
                height: EC_Fmt.isMobile ? "auto" : 390,
                barPosition: "top",
                cancelButtonTitle: "Cancel",
                confirmButtonTitle: "Log in",
                confirmButtonAction(dialog) {
                    EC_Fmt.TriggerEvent(dialog.querySelector("#ews-login-form"), "submit");
                }
            });

            Dialog.classList.add("ecp-Logon-dialog");
            UniqueLogonDialog = false;
            // Task 643544: Timeout login popup redirects the user to the login page
            const otherLogin = Dialog.querySelector(".other-login");
            const oAuthTitle = Dialog.querySelector(".o-auth-title");
            if (otherLogin) {
                otherLogin.style.position = "absolute";
                otherLogin.style.top = "140px";
                oAuthTitle.style.margin = "20px 0 13px 0";
            }

            // Task 1123508: Incorrect dialog button padding
            if (EC_Fmt.isMobile) {
                if (otherLogin) {
                    otherLogin.setAttribute("style", "");
                    oAuthTitle.setAttribute("style", "margin-top:10%");
                    Dialog.querySelector("#reset-pwd-btn").setAttribute("style", "line-height:inherit;text-decoration:auto");
                }
            }

            const loginForm = Dialog.querySelector("#ews-login-form");

            loginForm.addEventListener("keydown", (event) => {
                if (event.key === "Enter") {
                    event.preventDefault();
                    EC_Fmt.TriggerEvent(loginForm, "submit");
                }
            });
            const usernameInput = Dialog.querySelector("#ews-login-username");
            usernameInput.focus();
            // Task 429466 - Updated to use <geolocation> HTML element (Chrome 144+) with fallback
            me.RequestGeolocation(loginForm);
            usernameInput.value = "";
            loginForm.querySelector("#ews-login-password").value = "";

            loginForm.querySelector("#Style").value = "";
            loginForm.querySelector("#Theme").value = "";

            ECP.Dialog.HideLoading();

            let working = false;

            loginForm.addEventListener("submit", (event) => {
                event.preventDefault();

                if (!working) {
                    working = true;

                    const LogonForm = me.EncryptLoginDivert(loginForm);
                    LogonForm.style.display = "none";

                    setTimeout(async () => {
                        ECP.Dialog.ShowLoading("Logging Back On...");
                        // Task 716545: Logging in through the 'login dialog' does not record the user's longitude and latitude
                        const result = await me.SubmitLogonRequest(
                            LogonForm.querySelector("#Style").value,
                            LogonForm.querySelector("#Theme").value,
                            LogonForm.querySelector("#Latitude").value,
                            LogonForm.querySelector("#Longitude").value
                        );
                        if (result.status === "requireMFA") {
                            ECP.Dialog.HideLoading();
                            const mfaResult = await EWS.CheckMFAStatus(result.message, result.type, result.token, result.passkeyOptions);
                            if (mfaResult === "True") {
                                result.status = "success";
                            } else {
                                result.status = "fail";
                                result.message = mfaResult;
                            }
                        }

                        if (result.status === "success") {
                            ECP.Dialog.CloseDialog(Dialog);
                            me.StartPageTimer();
                            me.ReLogin();

                            if (!EC_Fmt.isNull(callback)) {
                                ECP.Dialog.HideLoading();
                                callback();
                            }
                        } else if (result.status === "expired") {
                            window.location.href = `../aspx1/Home?DashboardID=168087`;
                        } else if (result.message.indexOf("2|") === 0) {
                            ECP.Dialog.CloseDialog(Dialog);
                            LogonForm.style.display = "block";
                            const loginDialogData = await DisplayLogon(result.message);
                            ECP.Dialog.ShowDialog("Logon", loginDialogData, { height: 345, disableButtons: true });
                        } else {
                            ECP.Dialog.Alert(result.message);

                            ECP.Dialog.HideLoading();
                            LogonForm.style.display = "block";

                            working = false;
                        }
                        ECP.Dialog.HideLoading();
                        LogonForm.style.display = "block";
                        if (result.status === "success" && !EC_Fmt.isMobile) {
                            // Task 758982: Remind Me is replaced by Username@EncompassID when Session Expired
                            const labelButtons = document.getElementById("UserMenuToggle");
                            if (!EC_Fmt.isNull(labelButtons)) {
                                labelButtons.innerHTML = result.username;
                            }
                        }
                    }, 250);
                }
                return false;
            });
        }
    }
};

BC_EWS.prototype.PageTimer = function (callback) {
    if (callback) {
        const current = this.OnPageTimer;

        if (typeof this.OnPageTimer !== "function") {
            this.OnPageTimer = callback;
        } else {
            this.OnPageTimer = function (EWS) {
                if (current) {
                    current(EWS);
                }

                callback(EWS);
            };
        }
    } else {
        if (!IsImpersonateUser) {
            this.VerifySession();
        }
        if (this.OnPageTimer) {
            this.OnPageTimer(this);
        }
    }
};

BC_EWS.prototype.Post = (html) => {
    const form = EC_Fmt.HtmlStrToElement(html);
    form.style.display = "none";
    document.body.appendChild(form);
    form.submit();
};

BC_EWS.prototype.EwsIsReady = false;

BC_EWS.prototype.Ready = function (callback) {
    if (callback) {
        if (this.EwsIsReady) {
            callback(EWS);
        } else {
            const current = this.OnReady;

            this.OnReady = function (EWS) {
                EWS.EwsIsReady = true;

                if (current) {
                    current(EWS);
                }
                callback(EWS);
            };
        }
    } else if (this.OnReady) {
        this.OnReady(this);
    }
};

BC_EWS.prototype.ReLogin = function (callback) {
    if (callback) {
        const current = this.OnReLogin;

        if (typeof this.OnReLogin !== "function") {
            this.OnReLogin = callback;
        } else {
            this.OnReLogin = function (EWS) {
                if (current) {
                    current(EWS);
                }

                callback(EWS);
            };
        }
    } else if (this.OnReLogin) {
        this.OnReLogin(this);
    }
};

BC_EWS.prototype.TipsPosition = (Container) => {
    const dashboardTipsContainer = Container.querySelector(".ews-dashboard-tips-container");
    if (dashboardTipsContainer) {
        dashboardTipsContainer.addEventListener("mouseover", (event) => {
            const BoundingRect = event.currentTarget.getBoundingClientRect();

            const dashboardTipsDescription = event.currentTarget.querySelector(".ews-dashboard-tips-description");
            dashboardTipsDescription.style.top = (BoundingRect.top + 23);
            dashboardTipsDescription.style.left = (BoundingRect.left - 20);
            dashboardTipsDescription.style.display = "block";

            event.currentTarget.querySelector(".ews-icon-info-label").classList.add("on");
        });

        const nonFocusFunc = (event) => {
            event.currentTarget.querySelector(".ews-dashboard-tips-description").style.display = "none";
            event.currentTarget.querySelector(".ews-icon-info-label").classList.remove("on");
        };

        dashboardTipsContainer.addEventListener("mouseout", nonFocusFunc);
        dashboardTipsContainer.addEventListener("mousewheel", nonFocusFunc);
    }
};

BC_EWS.prototype.Resize = function (callback) {
    if (callback) {
        const current = this.OnResize;

        if (typeof this.OnResize !== "function") {
            this.OnResize = callback;
        } else {
            this.OnResize = function (EWS) {
                if (current) {
                    current(EWS);
                }

                callback(EWS);
            };
        }
    } else if (!EC_Fmt.isMobile && this.AllowResize) {
        if (this.OnResize) {
            this.OnResize(this);
        }
    }
};

BC_EWS.prototype.VerifySession = function (successCallback, postBack, errorCallback, failCallback) {
    const me = this;
    // Task 686528: Add 'No internet connection' prompt when EC_Request in the SDK tries to call to the server without an internet connection
    // EC-29365: Skip offline check when Service Worker caching is enabled for this dashboard
    if (!navigator.onLine && !BC_EWS.OfflineCacheEnabled) {
        if (!BC_EWS.NoInternetDialog || !EC_Fmt.isVisible(BC_EWS.NoInternetDialog)) {
            // Task 713357: Javascript error: Failed to execute 'removeChild' on 'Node': parameter 1 is not of type 'Node'.
            clearInterval(BC_EWS.NoInternetDialogInterval);
            BC_EWS.NoInternetDialog = ECP.Dialog.Alert("No Internet Connection");
            BC_EWS.NoInternetDialogInterval = setInterval(() => {
                if (navigator.onLine) {
                    if (BC_EWS.NoInternetDialog) {
                        BC_EWS.NoInternetDialog.remove();
                    }
                    BC_EWS.NoInternetDialog = undefined;
                    clearInterval(BC_EWS.NoInternetDialogInterval);
                }
            }, 1000);
        }
        if (!EC_Fmt.isNull(failCallback)) {
            failCallback("No Internet Connection");
        }
    } else {
        let AvailableLogonDialog = false;
        const loginDialog = document.querySelector(".ecp-Logon-dialog");
        if (loginDialog) {
            AvailableLogonDialog = true;
            if (loginDialog.style.display === "none") {
                AvailableLogonDialog = false;
            }
        }
        const localTimeStamp = new Date().getTime();
        const expireTimestamp = EC_Fmt.Null2ZeroInt(EC_Fmt.GetCookie("ExpireTime"));

        if (localTimeStamp > expireTimestamp || (localTimeStamp <= expireTimestamp && AvailableLogonDialog) || EC_Fmt.GetCookie("Guest") === "True") {
            // Task 660080: Pre-delivery, post-delivery Invoice: When a customer opens an Invoice via Invoice Link, user is getting prompted to log in.
            fetch(`api?APICommand=VerifySession_Guest&IsImpersonateUser=${IsImpersonateUser}&EncompassID=${Distributor}&APIToken=33c9305a94a58896fd87f0efd2411380`, {
                credentials: "same-origin"
            }).then(response => response.json()).then((result) => {
                if (!result.valid) {
                    if (!postBack) {
                        me.StopPageTimer();

                        if (UserType !== "Guest") {
                            // Task 603368: When Session Cookies expire, EWS.VerifySession fails to validate Session correctly.
                            if (EC_Fmt.Null2EmptyStr(EC_Fmt.GetCookie("EncompassID")) !== "") {
                                me.Login(successCallback);
                            }
                            me.VerifySessionFail();
                        }
                    } else if (!EC_Fmt.isNull(failCallback)) {
                        failCallback(result);
                    }
                } else if (!EC_Fmt.isNull(successCallback)) {
                    successCallback();
                }
            }).catch(() => {
                // Task 346363
                if (!EC_Fmt.isNull(errorCallback)) {
                    errorCallback();
                }
            });
        } else if (localTimeStamp <= expireTimestamp && !AvailableLogonDialog && UserType !== "Guest" && !EC_Fmt.isNull(successCallback)) {
            successCallback();
        }
    }
};

// Task 442006: Add ability to 'barge' onto an ongoing call in Encompass Voice
BC_EWS.prototype.bargeCall = function (CallID, UserID) {
    const data = new FormData();
    data.append("CallID", CallID);
    data.append("AuthenticationID", AuthenticationID);
    data.append("UserID", UserID);
    // Task 688375: Pallet IDs are not being added in incremental packages
    fetch("api?APICommand=SalesComm_VoiceControls_Barge", {
        credentials: "same-origin",
        method: "POST",
        body: data
    }).then(response => response.json()).then((results) => {
        if (results.status !== "success") {
            ECP.Dialog.Alert(results.message);
            // Task 631558: Unable to Barge phone-calls when clicking Barge. User is receiving a JavaScript Error: UnknownFile (0) - Error in promise - ReferenceError: autoAccept is not defined error.
        }
    });
};

// Task 610406: Call fails when I click the phone number on a task.
BC_EWS.prototype.Click2Call = function (Identity, ToNumber, UserID, TaskID) {
    // Task 918041: Sales Center- Outbound call had voicemail message playing when person answers
    if (!Identity) {
        if (AuthenticationID) {
            Identity = `client:${AuthenticationID}`;
        } else {
            ECP.Dialog.Alert("AuthenticationID is empty.");
            return;
        }
    }
    ToNumber = ToNumber.toLowerCase();

    if (ToNumber === Identity) {
        ECP.Dialog.Alert("You may not call yourself");
    } else {
        const request = function () {
            window.localStorage.setItem("autoAccept", "true");
            const myRequest = new ECP.EC_Request(`SalesComm_VoiceControls_NewOutBoundCall`);
            myRequest.SetReturnType(ECP.EC_ReturnType.Text);
            myRequest.AddRequestVariable("Identity", Identity, ECP.EC_Verb.Post);
            myRequest.AddRequestVariable("ToNumber", ToNumber, ECP.EC_Verb.Post);
            myRequest.AddRequestVariable("ToUserID", UserID, ECP.EC_Verb.Post);
            myRequest.AddRequestVariable("TaskID", TaskID, ECP.EC_Verb.Post);
            myRequest.Submit();

            setTimeout(() => {
                window.localStorage.setItem("autoAccept", "false");
            }, 5000);
        };

        const temp = window.localStorage.getItem("ActiveDialerCount");
        let count = 0;
        if (temp) {
            count = parseInt(temp);
        }

        if (count > 0) {
            request();
            if (Settings.DashboardID !== 138848) {
                ECP.Dialog.Alert("The call is placed in Call Manager dashboard.");
            }
        } else {
            window.open("Home?DashboardID=138848").focus();

            setTimeout(() => {
                request();
            }, 5000);
        }
    }
};

BC_EWS.prototype.VerifySessionFail = function (callback) {
    if (callback) {
        const current = this.OnVerifySessionFail;

        if (typeof this.OnVerifySessionFail !== "function") {
            this.OnVerifySessionFail = callback;
        } else {
            this.OnVerifySessionFail = function (EWS) {
                if (current) {
                    current(EWS);
                }

                callback(EWS);
            };
        }
    } else if (this.OnVerifySessionFail) {
        this.OnVerifySessionFail(this);
    }
};

BC_EWS.prototype.EnterFullscreen = function (callback, refresh) {
    // Task 1033298: Adding Google Analytics as a default feature of dashboards
    gtag("event", "enterFullscreen");
    const me = this;
    const body = document.body;
    // Task 644280: In ECP 20.01, Run Test Case 3931 fail
    const FullscreenEnabled = (body.requestFullscreen || body.webkitRequestFullscreen);

    if (FullscreenEnabled && body) {
        const FullScreenChangeFunction = () => {
            if (me.Fullscreen) {
                me.ExitFullscreen();
            } else {
                me.Fullscreen = true;
            }
        };

        body.classList.add("ews-fullscreen");

        // Listen only for the change event that pairs with the API used to enter, so the toggle runs once per transition
        if (body.requestFullscreen) {
            document.addEventListener("fullscreenchange", FullScreenChangeFunction);
            body.requestFullscreen();
        } else {
            document.addEventListener("webkitfullscreenchange", FullScreenChangeFunction);
            body.webkitRequestFullscreen();
        }
        window.addEventListener("beforeunload", () => {
            if (me.Fullscreen) {
                me.ExitFullscreen();
            }
        });

        if (!EC_Fmt.isNull(callback) && EC_Fmt.isNumber(refresh) && refresh > 0) {
            if (refresh < 15000) {
                refresh = 15000;
            }
            this.FullscreenTimer = setInterval(() => {
                callback();
            }, refresh);
        }
    }
};

BC_EWS.prototype.ExitFullscreen = function () {
    const me = this;
    const FullscreenEnabled = (document.fullscreenElement || document.webkitFullscreenElement);

    if (FullscreenEnabled) {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else {
            document.webkitExitFullscreen();
        }
    }

    if (me.Fullscreen) {
        me.Fullscreen = false;
        clearTimeout(me.FullscreenTimer);

        // EC-34607: End Bev's Fin (Intercom) session with the ECP one
        EC_Fmt.ShutdownIntercom();
        window.location.href = "Home?LogOnType=LogOff";
    }
};

BC_EWS.prototype.StopBubble = (event) => {
    event.stopPropagation();
    return false;
};

BC_EWS.prototype.ShowMobileMenuMask = () => {
    const MobileBodyWrap = document.getElementById("MobileBodyWrap");
    if (MobileBodyWrap) {
        const menuMask = document.createElement("div");
        menuMask.classList.add("menu-mask", "Hideable");
        MobileBodyWrap.appendChild(menuMask);
    }
};

// Task 479843: Move call manager info/availability from User Field Audit to the TimeClockActivities
BC_EWS.prototype.SetStatus = function (Availability, TimeClockActivity, Memo) {
    const data = new FormData();
    const me = this;
    me.status = Availability;

    data.append("Availability", Availability);
    data.append("TimeClockActivity", TimeClockActivity);
    data.append("Memo", Memo);

    // Task 688375: Pallet IDs are not being added in incremental packages
    fetch("api?APICommand=SalesComm_VoiceControls_UpdateStatus", {
        credentials: "same-origin",
        method: "POST",
        body: data
    }).then(response => response.json()).then((result) => {
        if (result.status === "success") {
            // Task 957461: Call Status always says 'Unavailable' in collapsed user menu, even when actual status is Available or Busy
            const TimeClockActivityDisplayText = document.getElementById("TimeClockActivityDisplayText");
            if (result.Text && TimeClockActivityDisplayText) {
                TimeClockActivityDisplayText.textContent = result.Text;
            }

            const TimeClockActivityIcon = document.getElementById("TimeClockActivityIcon");
            if (result.Color && TimeClockActivityIcon) {
                TimeClockActivityIcon.style.color = result.Color;
            }

            // Task 961259: Dialer Status not updating right away
            const PhoneIcon = document.querySelector("div[name=CallManager] .ews-icon-phone");
            if (PhoneIcon && result.Color) {
                PhoneIcon.style.color = result.Color;
            }
        } else {
            EWS.Alert("Could not update status.");
        }
    });
};

BC_EWS.prototype.ClearMenuCache = (callback) => {
    fetch("api?APICommand=ResetMenuCache", {
        credentials: "same-origin"
    }).then(() => {
        if (!EC_Fmt.isNull(callback)) {
            callback();
        }
    });
};

// Task 637648: ReleaseNotes.HowToUse no longer shows full text editor. Unable to view all text in the field.
BC_EWS.prototype.InitControl = function (container) {
    EWS.Input.Init(container);

    const ajaxInputs = container.querySelectorAll("input[KeyValue][DisplayVal][LimitToList]");

    for (let i = 0; i < ajaxInputs.length; i++) {
        const FieldID = ajaxInputs[i].closest("section").getAttribute("FieldID");
        this.AjaxInputs[FieldID] = new ECP.HTML.AjaxInput(ajaxInputs[i]);
    }
};

BC_EWS.prototype.CheckMFAStatus = async function (message, type, MFAToken, passkeyOptions) {
    const myRequest = new ECP.EC_Request("MFA_CheckStatus");
    myRequest.SetReturnType(ECP.EC_ReturnType.Text);
    myRequest.SetAPIToken("c4927d3841234af6f81fbeb219afbf44");
    myRequest.AddRequestVariable("MFAToken", MFAToken, ECP.EC_Verb.Post);

    // a. A login request has been pushed to your primary device.
    // b. A message with a verification link has been sent to your email.
    // Task 1183470: Design system compliance: 2FA email
    let retryDialog = null;

    // Determine dialog title and footer based on type
    const isPasskey = type === "passkey";
    const dialogTitle = isPasskey ? "Verify with Passkey" : "Verify with Encompass Mobile";
    const dialogFooter = isPasskey
        ? "<div><ecp-btn class=use-authenticator-code type=secondary>Use Authenticator Code instead</ecp-btn></div>"
        : "<div><ecp-btn class=use-authenticator-code type=secondary>Use Authenticator Code instead</ecp-btn><ecp-btn class=no-login-request type=primary>Didn't Get a Login Request?</ecp-btn></div>";

    const dialog = ECP.Dialog.ShowDialog(
        dialogTitle,
        message,
        {
            barPosition: "top",
            footer: dialogFooter
        }
    );

    // If passkey, start authentication via popup on passkey.encompass8.com
    // This allows passkeys to work across different customer domains
    if (isPasskey && passkeyOptions) {
        startPasskeyAuthentication(MFAToken, dialog, passkeyOptions);
    }

    // Passkey authentication helper function - opens popup on passkey domain
    function startPasskeyAuthentication(mfaToken, passkeyDialog, options) {
        const dialogContent = passkeyDialog.querySelector(".ecp-dialog-content");

        // Check WebAuthn support
        if (!window.PublicKeyCredential) {
            dialogContent.innerHTML = "<center>Your browser does not support passkeys, please switch to a modern browser.</center>";
            return;
        }

        if (!options || !options.challenge) {
            dialogContent.innerHTML = "<center>Failed to get passkey options.</center>";
            return;
        }

        // Show button for user to click - iOS requires window.open() in synchronous user gesture
        dialogContent.innerHTML = "<center style=margin-top:25px><ecp-btn class=open-passkey-popup type=primary>Verify with Passkey</ecp-btn></center>";
        dialogContent.querySelector(".open-passkey-popup").addEventListener("click", () => {
            doPopupWebAuthn(mfaToken, passkeyDialog, options);
        });
    }

    // WebAuthn authentication via popup
    async function doPopupWebAuthn(mfaToken, passkeyDialog, options) {
        // Open popup IMMEDIATELY as first operation (iOS requires synchronous window.open in gesture handler)
        const popupWidth = 450;
        const popupHeight = 500;
        const left = (window.screen.width - popupWidth) / 2;
        const top = (window.screen.height - popupHeight) / 2;
        const popup = window.open(
            "about:blank",
            "PasskeyAuth",
            `popup=yes,width=${popupWidth},height=${popupHeight},left=${left},top=${top}`
        );

        const dialogContent = passkeyDialog.querySelector(".ecp-dialog-content");

        if (!popup) {
            dialogContent.innerHTML = "<center>Please allow popups to verify with your passkey.</center>";
            return;
        }

        dialogContent.innerHTML = "<center>Opening passkey verification...</center>";

        // Include session cookies in options for the popup to use
        // EC-31813: EncompassSessionID is deliberately not forwarded. It is HttpOnly now, and the popup
        // never needed it: Passkey_VerifyAuthentication_Guest authenticates off the MFAToken alone.
        const popupOptions = Object.assign({}, options, {
            session: {
                Email: EC_Fmt.GetCookie("Email"),
                EncompassDBServer: EC_Fmt.GetCookie("EncompassDBServer"),
                EncompassECPVersion: EC_Fmt.GetCookie("EncompassECPVersion"),
                EncompassID: EC_Fmt.GetCookie("EncompassID"),
                ExpireTime: EC_Fmt.GetCookie("ExpireTime"),
                LastUserTimeClockActivity: EC_Fmt.GetCookie("LastUserTimeClockActivity")
            }
        });

        // For localhost, use current origin; for production, use passkey domain
        const isLocalhost = options.rpId === "localhost";
        const passkeyDomain = isLocalhost ? window.location.origin : `https://${options.rpId}`;

        // Build popup URL with MFA token and options
        const optionsParam = encodeURIComponent(JSON.stringify(popupOptions));
        const popupUrl = `${passkeyDomain}/${EC_Fmt.GetCookie("EncompassECPVersion")}/BI/PasskeyAuthenticate.html?MFAToken=${encodeURIComponent(mfaToken)}&options=${optionsParam}`;

        // Navigate popup to actual URL
        popup.location.href = popupUrl;

        dialogContent.innerHTML = "<center>Complete verification in the popup window...</center>";

        // Listen for result from popup
        const messageHandler = async (event) => {
            // Verify origin is from passkey domain
            if (event.origin !== passkeyDomain) {
                return;
            }

            if (event.data && (event.data.type === "passkey-authenticated" || event.data.type === "passkey-auth-error")) {
                window.removeEventListener("message", messageHandler);

                if (event.data.success) {
                    dialogContent.innerHTML = "<center>Completing login...</center>";

                    // Call MFA_CheckStatus to trigger CompleteLogin on the server
                    // This sets up the session cookies
                    const checkRequest = new ECP.EC_Request("MFA_CheckStatus");
                    checkRequest.SetReturnType(ECP.EC_ReturnType.Text);
                    checkRequest.SetAPIToken("c4927d3841234af6f81fbeb219afbf44");
                    checkRequest.AddRequestVariable("MFAToken", mfaToken, ECP.EC_Verb.Post);
                    const checkResult = await checkRequest.Submit();

                    if (checkResult === "True") {
                        dialogContent.innerHTML = "<center>Succeeded.</center>";
                        ECP.Dialog.CloseDialog(passkeyDialog);
                    } else {
                        dialogContent.innerHTML = `<center>Login failed: ${checkResult}</center>`;
                    }
                } else {
                    dialogContent.innerHTML = `<center>${event.data.error || "Passkey verification failed."}</center>`;
                }
            }
        };
        window.addEventListener("message", messageHandler);

        // Also check if popup was closed without completing
        const checkPopupClosed = setInterval(() => {
            if (popup.closed) {
                clearInterval(checkPopupClosed);
                window.removeEventListener("message", messageHandler);
                // Only update if dialog is still showing the "Complete verification" message
                if (dialogContent.innerHTML.includes("Complete verification")) {
                    dialogContent.innerHTML = "<center>Passkey verification was cancelled.</center>";
                }
            }
        }, 500);
    }

    dialog.querySelector(".use-authenticator-code").addEventListener("click", () => {
        dialog.style.display = "none";
        const AuthenticatorDialog = ECP.Dialog.ShowDialog(
            "Verify with Authenticator Code",
            `<div>`
            + `<p>Enter the code displayed in the Authenticator App on your phone.</p>`
            + `<p style="margin-top:1rem"><div><ecp-input class=totp-code-input type=number placeholder=XXXXXX></ecp-input></div></p>`
            + `</div>`,
            {
                barPosition: "top",
                width: 380,
                height: 240,
                disableResize: true,
                cancelButtonTitle: "Cancel",
                cancelButtonAction: () => {
                    dialog.style.display = "block";
                    // Re-trigger passkey if going back
                    if (isPasskey && passkeyOptions) {
                        startPasskeyAuthentication(MFAToken, dialog, passkeyOptions);
                    }
                },
                confirmButtonAction: async () => {
                    await Verify_TimeBasedOneTimePassword();
                }
            }
        );
        const confirmBtn = AuthenticatorDialog.querySelector(".ecp-dialog-confirm-button");
        confirmBtn.disabled = true;

        const codeInput = AuthenticatorDialog.querySelector(".totp-code-input");
        codeInput.focus();
        codeInput.addEventListener("input", () => {
            const code = EC_Fmt.Left(codeInput.value, 6);
            codeInput.value = code;
            confirmBtn.disabled = code.length !== 6;
            if (code.length === 6) {
                Verify_TimeBasedOneTimePassword();
            }
        });

        async function Verify_TimeBasedOneTimePassword() {
            ECP.Dialog.ShowLoading();
            const myAuthRequest = new ECP.EC_Request("Verify_TimeBasedOneTimePassword");
            myAuthRequest.SetAPIToken("c4927d3841234af6f81fbeb219afbf44");
            myAuthRequest.AddRequestVariable("MFAToken", MFAToken, ECP.EC_Verb.Post);
            myAuthRequest.AddRequestVariable("Code", codeInput.value, ECP.EC_Verb.Post);
            try {
                const response = await myAuthRequest.Submit();
                if (response.Success) {
                    AuthenticatorDialog.style.display = "none";
                    ECP.HTML.Snackbar("Success", "Success");
                    if (isPasskey) {
                        await myRequest.Submit();
                        window.location.reload();
                    }
                } else {
                    ECP.HTML.Snackbar(response.Error, "Error");
                    ECP.Dialog.HideLoading();
                }
            } catch (error) {
                ECP.HTML.Snackbar(error, "Error");
                ECP.Dialog.HideLoading();
            }
        }
    });

    // Only add the "Didn't Get a Login Request?" handler for non-passkey flows
    const noLoginRequestBtn = dialog.querySelector(".no-login-request");
    if (noLoginRequestBtn) {
        noLoginRequestBtn.addEventListener("click", () => {
            dialog.style.display = "none";
            retryDialog = ECP.Dialog.ShowDialog(
                "Didn't Get a Login Request?",
                `<div style=display:flex;flex-direction:column;align-items:center>${type === "loginRequest" ? `<ecp-btn class=re-push id=push2em width=310px>Re-push a login request to my primary device</ecp-btn>` : ""
                }<ecp-btn class=send-mail id=push2email width=310px>Send me an email with a verification link</ecp-btn></div>`,
                {
                    barPosition: "top",
                    width: 380,
                    height: 180,
                    disableButtons: true,
                    disableResize: true,
                    cancelButtonAction: () => {
                        dialog.style.display = "block";
                    }
                }
            );
            const retryFunction = async (retryType) => {
                ECP.Dialog.ShowLoading();
                if (retryDialog) {
                    ECP.Dialog.CloseDialog(retryDialog);
                }
                const myRetryRequest = new ECP.EC_Request("MFA_PushLoginRequest");
                myRetryRequest.SetReturnType(ECP.EC_ReturnType.Text);
                myRetryRequest.SetAPIToken("c4927d3841234af6f81fbeb219afbf44");
                myRetryRequest.AddRequestVariable("MFAToken", MFAToken, ECP.EC_Verb.Post);
                myRetryRequest.AddRequestVariable("Type", retryType, ECP.EC_Verb.Post);
                const response = await myRetryRequest.Submit();
                ECP.Dialog.HideLoading();
                if (response === "True") {
                    ECP.HTML.Snackbar("Success", "Success");
                } else {
                    ECP.HTML.Snackbar(response, "Error");
                }
                dialog.style.display = "block";
            };
            const push2em = document.getElementById("push2em");
            if (!EC_Fmt.isNull(push2em)) {
                push2em.addEventListener("click", () => { retryFunction("EM"); });
            }
            document.getElementById("push2email").addEventListener("click", () => { retryFunction("Email"); });
            retryDialog.querySelector(".ecp-dialog-footer").style.minHeight = "8px";
        });
    }

    // For passkey, we don't poll MFA_CheckStatus - the passkey flow handles verification directly
    // For other types, we poll MFA_CheckStatus
    if (isPasskey) {
        // Passkey flow handles its own success/failure - just return a promise that resolves when dialog closes
        return new Promise((resolve) => {
            const observer = new MutationObserver(() => {
                if (!document.body.contains(dialog)) {
                    observer.disconnect();
                    resolve("True");
                }
            });
            observer.observe(document.body, { childList: true, subtree: true });
        });
    }

    let result;
    try {
        result = await myRequest.Submit();
    } catch (e) {
        // Sleep
        await new Promise(r => setTimeout(r, 300));
        result = await myRequest.Submit();
    }

    if (result === "True") {
        dialog.querySelector(".ecp-dialog-content").innerHTML = "<center>Succeeded.</center>";
        if (retryDialog) {
            ECP.Dialog.CloseDialog(retryDialog);
        }
        if (dialog) {
            ECP.Dialog.CloseDialog(dialog);
        }
    } else {
        ECP.HTML.Snackbar(result, "Error");
        if (retryDialog) {
            ECP.Dialog.CloseDialog(retryDialog);
        }
        if (dialog) {
            dialog.querySelector(".ecp-dialog-content").innerHTML = `<center>${result}</center>`;
        }
    }
    return result;
};

// eslint-disable-next-line no-var, no-redeclare -- this is the declaration of the EWS global that eslint.config.cjs registers for every other script
var EWS = new BC_EWS();

// Remove File NumCompCommon_INC.js
function NumComp(val) {
    // Task 671357: In the Invoice Edit ,it convert num 1/2 to null
    const result = EC_Fmt.MathEval(EC_Fmt.CleanNumberStr(val), val);
    return EC_Fmt.CDec(result);
}

function Zero2Empty(num) {
    const myNum = EC_Fmt.Null2Zero(num);
    return (myNum === "0") ? "" : myNum;
}

function SearchURL(Field, val) {
    return encodeURIComponent(`|F:${Field}~V:${val}|`);
}

function isNumber(val) {
    return EC_Fmt.isNumber(val);
}

function Null2Zero(val) {
    return EC_Fmt.Null2Zero(val);
}

// Task 550319: Add a 'warning' when the user has caps lock on when typing in a password
function isCapsLock(PasswordInput) {
    const warnCapsLockElement = document.getElementsByName("warn-capital");

    // Task 614037: Hitting the 'enter' key on the password field for the pop-up log in dialog does not log in the user if the page has other text inputs on it
    PasswordInput.addEventListener("keypress", (event) => {
        // Task 758297: The login page on the iPad browser displays an error
        if (event.getModifierState) {
            const display = event.getModifierState("CapsLock") ? "block" : "none";
            for (let i = 0, len = warnCapsLockElement.length; i < len; i++) {
                warnCapsLockElement[i].style.display = display;
                if (document.getElementById("ecp-logon-tips")) {
                    document.getElementById("ecp-logon-tips").firstChild.style.minHeight = 0;
                }
            }
        }
    });
}

HTMLCollection.prototype.remove = function () {
    for (let i = this.length - 1; i >= 0; i--) {
        if (this[i] && this[i].parentElement) {
            this[i].parentElement.removeChild(this[i]);
        }
    }
};

// Task 598296: iOS Safari can't logon with session expire pop up if you have 2 user records
async function DisplayLogon(message) {
    const myRequest = new ECP.EC_Request("WriteLogon_Guest");
    myRequest.SetAPIToken("33c9305a94a58896fd87f0efd2411380");
    // Task 935369: Users logging in to Encompass get a frozen loading page after entering in their password.
    myRequest.SetReturnType(ECP.EC_ReturnType.Text);
    myRequest.AddRequestVariable("Request", "DialogLogon");
    myRequest.AddRequestVariable("Message", message, ECP.EC_Verb.Post);
    const response = await myRequest.Submit();
    return response;
}
// Task 598296: iOS Safari can't logon with session expire pop up if you have 2 user records
async function DialogLogon() {
    const form = document.getElementById("LoginForm");

    let username = form.querySelector("#UserNameHidden").value;
    let support = false;

    username = username.toLowerCase().trim();

    if (username.endsWith("$")) {
        username = username.slice(0, -1);
        support = true;
    }

    username = EC_Fmt.MD5(username);

    if (support) {
        username += "$";
    }

    form.querySelector("#Style").value = username;

    ECP.Dialog.ShowLoading();
    ECP.Dialog.CloseDialog(document.getElementById(form.parentElement.parentElement.parentElement.parentElement.parentElement.id));

    const buildRequest = (captchaToken, captchaTokenV2) => {
        const request = new ECP.EC_Request("Logon_Guest");
        request.SetAPIToken("33c9305a94a58896fd87f0efd2411380");
        request.AddRequestVariable("Style", form.querySelector("#Style").value, ECP.EC_Verb.Post);
        request.AddRequestVariable("Theme", form.querySelector("#Theme").value, ECP.EC_Verb.Post);
        request.AddRequestVariable("EncompassID", Distributor, ECP.EC_Verb.Post);
        request.AddRequestVariable("CaptchaToken", captchaToken, ECP.EC_Verb.Post);
        request.AddRequestVariable("CaptchaTokenV2", captchaTokenV2, ECP.EC_Verb.Post);
        return request;
    };

    const v3Token = await GetLoginCaptchaV3Token();
    let result = await buildRequest(v3Token, "").Submit();

    if (result.status === "requireCaptcha") {
        const v2Token = await ShowLoginCaptchaChallenge();
        if (EC_Fmt.isNull(v2Token)) {
            result = { status: "fail", message: "Verification was not completed. Please try again." };
        } else {
            result = await buildRequest("", v2Token).Submit();
        }
    }

    if (result.status !== "expired" && result.status !== "success") {
        // Task 1166514: Unable to login via MFA if the site has multiple users under the same authentication
        if (result.status === "requireMFA") {
            ECP.Dialog.HideLoading();
            const mfaResult = await EWS.CheckMFAStatus(result.message, result.type, result.token, result.passkeyOptions);
            if (mfaResult === "True") {
                result.status = "success";
            } else {
                result.status = "fail";
                result.message = mfaResult;
            }
        } else {
            EWS.Login();
            EWS.VerifySessionFail();
            setTimeout(EWS.Alert(result.message), 250);
        }
    }
    form.style.display = "block";
    ECP.Dialog.HideLoading();
    if (result.status === "success") {
        const labelButtonElement = document.getElementsByClassName("Label Right LabelButton");
        if (!labelButtonElement || labelButtonElement.length === 0 || EC_Fmt.isNull(labelButtonElement[0])) {
            const destURLElement = document.getElementById("DestURL");
            if (!destURLElement || EC_Fmt.isNull(destURLElement.value)) {
                window.location.href = "Home";
            } else {
                window.location.href = destURLElement.value;
            }
        } else {
            labelButtonElement[0].innerHTML = result.username;
        }
    }
}

// Task 994583: Allow users to Show/Hide their password in mobile & server login boxes
function showAndHiddenPassword() {
    const input = document.getElementById("ews-login-password");
    const icon = document.getElementById("passwordIcon");
    if (input.value !== "") {
        if (input.getAttribute("type") === "password") {
            input.setAttribute("type", "text");
            icon.classList.add("ews-icon-eye");
            icon.classList.remove("ews-icon-eyehide");
        } else {
            input.setAttribute("type", "password");
            icon.classList.add("ews-icon-eyehide");
            icon.classList.remove("ews-icon-eye");
        }
    }
}

NodeList.prototype.remove = HTMLCollection.prototype.remove;
